// removed by extract-text-webpack-plugin
module.exports = {"logo-bg":"logo-bg_219E-","footer":"footer_qH4wl"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.less
// module id = 22
// module chunks = 0